import { render, staticRenderFns } from "./EstrattoConto.vue?vue&type=template&id=2a38773e"
import script from "./EstrattoConto.vue?vue&type=script&lang=js"
export * from "./EstrattoConto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports